import { Grid, Skeleton } from "@mantine/core";
import PageWrapperSkeleton from "../common/PageWrapperSkeleton";
import JobCardSkeleton from "../jobs/JobCardSkeleton";
import JobSmallCardSkeleton from "../jobs/JobSmallCardSkeleton";

const HomePageJobsSkeleton = () => {
  return (
    <>
      <PageWrapperSkeleton>
        <Grid gutter={0}>
          {Array.from(Array(8).keys()).map((expert, index) => (
            <Grid.Col span={12} md={6} lg={12} m={0} key={index}>
              <div className="hidden lg:block">
                <JobCardSkeleton className="my-2" />
              </div>
              <div className="block lg:hidden">
                <JobSmallCardSkeleton className="m-2" />
              </div>
            </Grid.Col>
          ))}
        </Grid>
      </PageWrapperSkeleton>
      <div className="flex justify-center my-[54px]">
        <Skeleton height={50} width={149} />
      </div>
    </>
  );
};

export default HomePageJobsSkeleton;
